import type { BankOnboarding } from 'src/interfaces/bankOnboarding'
import type { State } from '../reducers/types'

export const getBankOnboardings = (state: State): BankOnboarding[] => {
  return state.bankOnboarding.onboardings
}

export const getBankOnboardingsLoading = (state: State): boolean => {
  return state.bankOnboarding.loading
}

export const getBankOnboardingsError = (state: State): string | null => {
  return state.bankOnboarding.error
}

export const getBankOnboardingsLoadedKey = (state: State): string | null => {
  return state.bankOnboarding.loadedKey
}

export const getBankOnboardingSubmitting = (state: State): boolean => {
  return state.bankOnboarding.submitting
}
